import {styled} from '@mui/material';
import {Typography} from '@practicegenius/pg-ui/src/components/ResponsiveTypography';
import React from 'react';

const Wrapper = styled('div')(({theme}) => ({
  margin: theme.spacing(5, 2, 2, 2),
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

export const CatastrophicErrorScreen: React.FC = () => (
  <Wrapper>
    <Typography align="center" variant="pageTitle">
      Oops! There is a problem.
    </Typography>
  </Wrapper>
);
